import appdata from '../Services/appdata';
import {
  API_ROOT,
  dispatchGetJSONAsync,
  dispatchPostJSONAsync,
  completeJSONAsync,
} from './BaseApi';

async function getStrategyPlanHeaders() {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const url = `${API_ROOT}/planheader/${company.id}/${company_org_id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getStrategyEmployees() {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const url = `${API_ROOT}/planheader/${company.id}/${company_org_id}/employees`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addStrategyPlanHeader() {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const url = `${API_ROOT}/planheader/${company.id}/add`;
  let task = await dispatchPostJSONAsync(url, { company_org_id });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteStrategyPlanHeader(planheader_id) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/planheader/${company.id}/delete`;
  let task = await dispatchPostJSONAsync(url, {
    planheader_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateStrategyPlanHeader(updated_data, structure_mode = null) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/planheader/${company.id}/update`;
  let task = await dispatchPostJSONAsync(url, {
    updated_data,
    structure_mode,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

/*************************   Plan Details    ****************************/

async function getStrategyPlanDetails(planheader_id) {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const url = `${API_ROOT}/plandetail/${company.id}/${company_org_id}/${planheader_id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addStrategyPlanDetail(interval_cnt, selectedPlanId, newRowId) {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plandetail/${company.id}/add`;
  let task = await dispatchPostJSONAsync(url, {
    company_org_id,
    interval_cnt,
    planheader_id: selectedPlanId,
    create_user: user.first_name + ' ' + user.last_name,
    newRowId,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteStrategyPlanDetail(selectedPlanId, selectedIndex) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/plandetail/${company.id}/delete`;
  let task = await dispatchPostJSONAsync(url, {
    planheader_id: selectedPlanId,
    selectedIndex,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateStrategyPlanDetail(
  selectedIndex,
  updated_data,
  selectedPlanId,
  interval,
) {
  const company = appdata.getItem('company');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plandetail/${company.id}/update`;
  let task = await dispatchPostJSONAsync(url, {
    selectedIndex,
    updated_data,
    planheader_id: selectedPlanId,
    interval,
    modify_user: user.first_name + ' ' + user.last_name,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getStrategyPlanDetailWidth() {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plandetail/${company.id}/${company_org_id}/${user.id}/column/width`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function saveStrategyPlanDetailWidth(column_data) {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plandetail/${company.id}/${company_org_id}/column/width`;
  let task = await dispatchPostJSONAsync(url, {
    column_data,
    user_id: user.id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateStrategyPlanDetailInterval(
  planheader_id,
  interval_cnt,
  remove_first_interval = false,
  prepend_interval_count = 0,
) {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const url = `${API_ROOT}/plandetail/${company.id}/${company_org_id}/interval/update`;
  let task = await dispatchPostJSONAsync(url, {
    planheader_id,
    interval_cnt,
    remove_first_interval,
    prepend_interval_count,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

/*************************   Plan Summaries    ****************************/

async function getStrategyPlanSummaries(planheader_id) {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const url = `${API_ROOT}/plansummary/${company.id}/${company_org_id}/${planheader_id}`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function addStrategyPlanSummary(selectedPlanId) {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plansummary/${company.id}/add`;
  let task = await dispatchPostJSONAsync(url, {
    company_org_id,
    planheader_id: selectedPlanId,
    create_user: user.first_name + ' ' + user.last_name,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function deleteStrategyPlanSummary(plansummary_id) {
  const company = appdata.getItem('company');
  const url = `${API_ROOT}/plansummary/${company.id}/delete`;
  let task = await dispatchPostJSONAsync(url, {
    plansummary_id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function updateStrategyPlanSummary(updated_data) {
  const company = appdata.getItem('company');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plansummary/${company.id}/update`;
  let task = await dispatchPostJSONAsync(url, {
    updated_data,
    modify_user: user.first_name + ' ' + user.last_name,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function getStrategyPlanSummaryWidth() {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plansummary/${company.id}/${company_org_id}/${user.id}/column/width`;
  let task = await dispatchGetJSONAsync(url);
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

async function saveStrategyPlanSummaryWidth(column_data) {
  const company = appdata.getItem('company');
  const company_org_id = appdata.getItem('company_org_id');
  const user = appdata.getItem('user');
  const url = `${API_ROOT}/plansummary/${company.id}/${company_org_id}/column/width`;
  let task = await dispatchPostJSONAsync(url, {
    column_data,
    user_id: user.id,
  });
  if (!task) {
    return [];
  }
  return await completeJSONAsync(task);
}

const ApiStrategy = {
  getStrategyPlanHeaders,
  getStrategyEmployees,
  addStrategyPlanHeader,
  deleteStrategyPlanHeader,
  updateStrategyPlanHeader,
  getStrategyPlanSummaries,
  addStrategyPlanSummary,
  deleteStrategyPlanSummary,
  updateStrategyPlanSummary,
  getStrategyPlanDetails,
  addStrategyPlanDetail,
  deleteStrategyPlanDetail,
  updateStrategyPlanDetail,
  getStrategyPlanDetailWidth,
  saveStrategyPlanDetailWidth,
  updateStrategyPlanDetailInterval,
  getStrategyPlanSummaryWidth,
  saveStrategyPlanSummaryWidth,
};

export default ApiStrategy;
